<template>
  <div :class="`tw-w-full tw-flex tw-flex-col`">
    <div
      :class="`tw-min-h-[44px] tw-cursor-pointer tw-flex tw-justify-between tw-items-center tw-self-stretch tw-py-[10px] tw-pl-[24px] tw-pr-[21px] ${
        level === 1 ? '!tw-pl-[57px] !tw-pr-[21px]' : ''
      }`"
      @click="onClickAssessmentItem"
    >
      <div
        class="tw-cursor-pointer tw-flex tw-justify-center tw-items-center tw-gap-[8px]"
        data-cy="assessment-switcher-dropdown-item"
      >
        <span
          v-if="
            item && item?.checklistDateReporting
              ? item?.checklistDateReporting
              : item?.checklistDateCreated
          "
          :class="`tw-text-[#231F20] tw-text-[11px] tw-not-italic tw-font-[400] tw-leading-[130%] title tw-line-clamp-2 tw-flex-1 ${
            item.isHidden ? 'tw-opacity-50' : ''
          }`"
          ><span class="tw-font-[500]">{{ item?.checklistName }}</span
          >{{
            ` - ${convertUTCTimeToLocalTime(
              item?.checklistDateReporting
                ? item?.checklistDateReporting
                : item?.checklistDateCreated,
            )}`
          }}</span
        >
        <AssessmentChecklistStatusTag
          :checklist-status="item.checklistStatus"
          :checklist-status-id="item.checklistStatusId"
          :is-loading="false"
          :class-name="` tw-px-[8px] tw-leading-[130%] tw-h-[24px] ${
            item.isHidden ? 'tw-opacity-50' : ''
          }`"
        />
      </div>
      <span
        v-if="item.checklistParent && level === 0 && !isTopLevelOnly"
        :class="`arrowIcon ${
          isOpen ? 'rotated tw-pr-[10px]' : 'tw-pl-[10px] '
        } `"
        @click.stop
        @click="
          () => {
            isOpen = !isOpen;
          }
        "
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="7"
          viewBox="0 0 10 7"
          fill="none"
        >
          <path
            d="M0.104884 2.00642L4.67976 7.19266C4.72096 7.23621 4.77061 7.2709 4.82567 7.2946C4.88073 7.31831 4.94005 7.33054 5 7.33054C5.05995 7.33054 5.11927 7.31831 5.17433 7.2946C5.22939 7.2709 5.27904 7.23621 5.32024 7.19266L9.89512 2.00642C9.93169 1.96522 9.95972 1.91717 9.97757 1.86505C9.99541 1.81293 10.0027 1.75778 9.99909 1.70281C9.99458 1.6474 9.97901 1.59345 9.95329 1.54417C9.92758 1.49488 9.89224 1.45124 9.84937 1.41584L9.07996 0.771202C9.03793 0.734847 8.98904 0.707283 8.93618 0.690139C8.88332 0.672995 8.82756 0.666619 8.77219 0.671387C8.71709 0.675373 8.66333 0.690299 8.61406 0.715292C8.56479 0.740285 8.52099 0.774843 8.48522 0.816951L5.0707 4.74718C5.04968 4.76801 5.02128 4.77969 4.99168 4.77969C4.96209 4.77969 4.93369 4.76801 4.91266 4.74718L1.51478 0.816951C1.44755 0.736646 1.35249 0.684663 1.2486 0.671387C1.19352 0.666053 1.13793 0.671766 1.08508 0.688192C1.03223 0.704618 0.983193 0.731424 0.940838 0.767043L0.150633 1.41584C0.107763 1.45124 0.0724248 1.49487 0.0467083 1.54417C0.0209918 1.59345 0.0054186 1.6474 0.000909419 1.70281C-0.00273159 1.75778 0.00458484 1.81293 0.0224338 1.86505C0.0402828 1.91717 0.0683087 1.96522 0.104884 2.00642Z"
            :fill="isOpen ? '#387DFF' : '#B7B7B7'"
          />
        </svg>
      </span>
    </div>

    <div
      v-if="isOpen && item && item.checklistParent && !isTopLevelOnly"
      class="items"
    >
      <assessmentSwitcherDropdownItem
        v-for="(child, index) of item.checklistParent"
        :key="index"
        :item="child"
        :level="level + 1"
        @update:selected="
          (cl) => {
            emits('update:selected', cl);
          }
        "
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { convertUTCTimeToLocalTime } from "@/utils/dateTimeUtils";
import AssessmentChecklistStatusTag from "@/components/assessment/assessmentChecklistStatusTag.vue";

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  searchValue: {
    type: String,
    required: false,
    default: "",
  },
  level: {
    type: Number,
    required: true,
    default: 0,
  },
  isModalOpen: {
    type: Boolean,
    required: false,
    default: false,
  },
  isTopLevelOnly: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const emits = defineEmits(["update:selected", "update:child-selected"]);
const isOpen = ref(false);
watch(
  () => props.isModalOpen,
  (value) => {
    if (!value && isOpen.value) {
      isOpen.value = false;
    }
    // if (
    //   value &&
    //   props.item?.checklistParent?.find(
    //     (item) => item.checklistId === currentChecklistReportId.value,
    //   )
    // ) {
    //   isOpen.value = true;
    // }
  },
);
watch(
  () => props.searchValue,
  (value) => {
    if (value && !isOpen.value) {
      isOpen.value = true;
    }
    if (!value && isOpen.value) {
      isOpen.value = false;
    }
  },
);
const onClickAssessmentItem = () => {
  emits("update:selected", props.item);
};
</script>

<style scoped>
.rotated {
  transform: rotate(180deg);
}

.items > *:not(:last-child) {
  border-bottom: 1px solid #eff0f1;
}

.items > *:first-child {
  border-top: 1px solid #eff0f1;
}
</style>
